module.exports = __webpack_public_path__ + "media/video5.8e4be60c.mp4";